/*jshint -W040*/
(function () {
    'use strict';

    angular
        .module('app.region')
        .component('rmapArea',
            {
                bindings: {
                    mode: '<',
                    model: '<',
                    onModeChanged: '&',
                    onAreaChanged: '&',
                    onModelReset: '&',
                    onStateRemoved: '&',
                    onSiteRemoved: '&'
                },
                templateUrl: 'app/region/dashboard/area/area.component.html',
                controller: areaComponentController,
                controllerAs: 'vm'
            });

    /* @ngInject */
    function areaComponentController(currentUser, logger, regionService, dialogService) {
        this.$onChanges = onChanges;

        var vm = this;
        var totalSites = 0;

        vm.loading = true;
        vm.originalAreas = [];
        vm.areas = [];
        vm.selection = {};
        vm.selectedArea = {};
        
        vm.clear = clear;
        vm.save = saveArea;
        vm.delete = deleteArea;

        vm.changeToCreateMode = changeToCreateMode;
        vm.areaSelectionChange = areaSelectionChange;
       
        function onChanges(changes) {
            if (changes.mode && changes.mode.currentValue.isEdit) {
                getAreas(vm.model.corporateid);
            }

            if (changes.model && changes.model.currentValue.corporateid !== changes.model.previousValue.corporateid) {
                if (vm.mode.isEdit) {
                    getAreas(changes.model.currentValue.corporateid);
                } else {
                    getTotalSitesCount(vm.model.corporateid);
                }
            }

            if (changes.model) {
                vm.model.totalSites = totalSites;
            }
        }

        function clear() {
            if (vm.mode.isCreate) {
                vm.onModelReset();
            } else {
                areaSelectionChange(vm.selectedArea);
            }
        }

        function reloadAreas() {
            getAreas(vm.model.corporateid);
        }

        function changeToCreateMode() {
            vm.mode.isEdit = false;
            vm.mode.isCreate = true;
            vm.onModeChanged({ mode: vm.mode });
        }

        function areaSelectionChange(area) {
            area.selectedSites = getSelectedSitesCount(area);
            vm.selectedArea = angular.copy(area);
            vm.model = angular.copy(area);
            vm.onAreaChanged({ area: area });
        }

        function getAreas(corporateId) {
            regionService.getAreas(corporateId, currentUser).then(function (result) {
                if (result.length > 0) {
                    vm.areas = result;
                    areaSelectionChange(result[0]);
                    getTotalSitesCount(corporateId);
                } else {
                    vm.areas = [];
                    resetModel();
                    vm.loading = false;
                }
            });
        }

        function getSelectedSitesCount(areaObject) {
            var selectedSitesCount = 0;
            angular.forEach(areaObject.states, function (state) {
                selectedSitesCount = selectedSitesCount + state.sites.length;
            });
            return selectedSitesCount;
        }
       
        function getTotalSitesCount(corporateId) {
            regionService.getStatesWithSites(corporateId).then(function (result) {
                if (result.status === 200) {
                    totalSites = 0;
                    angular.forEach(result.data, function(state) {
                        totalSites = totalSites + state.Sites.length;
                    });
                    vm.model.totalSites = totalSites;
                    vm.loading = false;
                } else {
                    vm.model.totalSites = 0;
                    vm.loading = false;
                }
            });
        }

        function resetModel() {
            var corporateid = vm.model.corporateid;
            vm.model = regionService.getDefaultAreaModel();
            vm.model.corporateid = corporateid;
            vm.onAreaChanged({ area: vm.model });
        }
       
        function saveArea() {
            if (!!vm.model.id) {
                dialogService.confirm('Update Area',
                        'Are you sure you want to update changes to this area?')
                    .then(function () {
                        return regionService.saveArea(vm.model);
                    }).then(function (result) {
                        onSaveandDeleteArea(result, 'update');
                    });
            } else {
                regionService.saveArea(vm.model)
                    .then(function (result) {
                        onSaveandDeleteArea(result, 'save');
                    });
            }
        }

        function deleteArea() {
            dialogService.confirm('Delete Area',
                    'Are you sure you want to delete this area?')
                .then(function () {
                    return regionService.deleteArea(vm.model);
                }).then(function (result) {
                    onSaveandDeleteArea(result, 'delete');
                });
        }

        function onSaveandDeleteArea(result, currentOperation) {
            if (result.status === 200) {
                logger.info('Area successfully ' + currentOperation + 'd');
                if (currentOperation === 'save') {
                    vm.onModelReset();
                } else {
                    reloadAreas();
                }
            } else if (result.status === 204) {
                logger.error('Error has occured. Please contact System Administrator.');
            }
        }
    }

})();
